import React from 'react';

const Blog = () => {
    return (
        <div className='text-white text-lg'>

            <div className='bg-violet-700 mb-10 w-4/5 mr-auto ml-auto p-5 '>
                <div className='font-bold pb-5'>
                    What is the Purpose of React router?
                </div>
                <div>
                    Routing is a process in which a user is directed to different pages based on their action or request. ReactJS Router is mainly used for developing Single Page Web Applications. React Router is used to define multiple routes in the application. When a user types a specific URL into the browser, and if this URL path matches any 'route' inside the router file, the user will be redirected to that particular route.

                    React Router is a standard library system built on top of the React and used to create routing in the React application using React Router Package. It provides the synchronous URL on the browser with data that will be displayed on the web page. It maintains the standard structure and behavior of the application and mainly used for developing single page web applications.
                    <br />
                    React Router plays an important role to display multiple views in a single page application. Without React Router, it is not possible to display multiple views in React applications. Most of the social media websites like Facebook, Instagram uses React Router for rendering multiple views.
                </div>
            </div>
            <div className='bg-violet-700 mb-10 w-4/5 mr-auto ml-auto p-5' >
                <div className='font-bold pb-5'>How does context API works?</div>
                <div>
                    Context API is a (kind of) new feature added in version 16.3 of React that allows one to share state across the entire app (or part of it) lightly and with ease. Let's see how to use it.
                    <br />
                    The React Context API is a way for a React app to effectively produce global variables that can be passed around. This is the alternative to "prop drilling" or moving props from grandparent to child to parent, and so on. Context is also touted as an easier, lighter approach to state management using Redux.
                    <br />
                    React.createContext() is all you need. It returns a consumer and a provider. Provider is a component that as it's names suggests provides the state to its children. It will hold the "store" and be the parent of all the components that might need that store. Consumer as it so happens is a component that consumes and uses the state.

                </div>
            </div>
            <div className='bg-violet-700 mb-10 w-4/5 mr-auto ml-auto p-5' >
                <div className='font-bold pb-5'>
                    Explain the React hook -'useRef'
                </div>
                <div>
                    The useRef Hook allows you to persist values between renders.

                    It can be used to store a mutable value that does not cause a re-render when updated.

                    It can be used to access a DOM element directly.
                    useRef() only returns one item. It returns an Object called current.
                    If we tried to count how many times our application renders using the useState Hook, we would be caught in an infinite loop since this Hook itself causes a re-render.

                    To avoid this, we can use the useRef Hook.

                    When we initialize useRef we set the initial value: useRef(0).

                </div>
            </div>


        </div>


    );
};

export default Blog;